import { Button } from '@mui/material';
import { ReactNode } from 'react';

interface PrimaryButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  title: string;
  disabled?: boolean;
}

export const PrimaryButton = ({
  onClick,
  title,
  disabled,
}: PrimaryButtonProps) => {
  return (
    <>
      <Button
        onClick={(e) => onClick(e)}
        variant="contained"
        disabled={disabled}
        sx={{
          backgroundColor: '#7B1FA2',
          '&:hover': { backgroundColor: '#5E167A' },
        }}
      >
        {title}
      </Button>
    </>
  );
};

export const SecondaryButton = ({
  onClick,
  title,
  disabled,
}: PrimaryButtonProps) => {
  return (
    <>
      <Button
        onClick={(e) => onClick(e)}
        variant="outlined"
        sx={{ color: '#bbb', borderColor: '#444' }}
        disabled={disabled}
      >
        {title}
      </Button>
    </>
  );
};

interface IconPrimaryButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  title: string;
  icon: ReactNode;
  height?: any;
  size?: 'small';
}

export const IconPrimaryButton = ({
  onClick,
  title,
  icon,
  height,
  size,
}: IconPrimaryButtonProps) => {
  return (
    <Button
      onClick={(e) => onClick(e)}
      variant="contained"
      startIcon={icon}
      size={size || 'medium'}
      sx={{
        backgroundColor: '#7B1FA2',
        '&:hover': { backgroundColor: '#7B1FA2' },
        color: '#FFFFFF',
        height: height,
        borderRadius: '15px',
        padding: '6px 12px',
        width: 'max-content',
        flexShrink: 0,
        whiteSpace: 'nowrap',
      }}
    >
      {title}
    </Button>
  );
};

interface IconTextButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  title: string;
  icon: ReactNode;
  height?: any;
}

export const IconTextButton = ({
  onClick,
  title,
  icon,
  height,
}: IconTextButtonProps) => {
  return (
    <Button
      onClick={(e) => onClick(e)}
      variant="text"
      startIcon={icon}
      sx={{
        color: '#bbb',
        '&:hover': { color: '#888', backgroundColor: 'transparent' },
        height: height,
      }}
    >
      {title}
    </Button>
  );
};
